import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Routes } from '@angular/router';
import { UserService } from 'src/app/data-services/user.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { first } from 'rxjs/operators';
import { MessageService } from 'src/app/data-services/message.service';
import { Message } from 'src/app/_models/message';
import { ChatService } from 'src/app/data-services/chat.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {
   
  [x: string]: any;
 id: any;
  userData: any = {};
  currentUser: any;
  friends = [];
  friendsname=[];
  language = '';
  direction;
  defaultLanguage;
  txtMessage: string = '';
  //uniqueID: string;
  messages = new Array<Message>();
  message = new Message();

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private chatService: ChatService,
    private _ngZone: NgZone
  ) {
      this.messageService.selectedLanguage.subscribe(res => {
        this.language = res.lang;
        this.direction = res.dir;
      }); 
      this.subscribeToEvents();
    }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => this.id = params.id);
    // this.getProfile();
    this.getMyFriends();
    this.defaultLanguage = JSON.parse(localStorage.getItem('language'));
    this.direction = this.defaultLanguage.dir;
  }
  // getProfile() {
  //   const data = {
  //     id: this.currentUser.success.user.id,
  //   };
  //   this.userService.getProfile(data).pipe(first()).subscribe(userData => this.userData = userData[0]);
  // }
  getMyFriends() {
    const data = {
      user_id: this.currentUser.success.user.id,
    };
    this.userService.getFriends(data).pipe(first<any[]>()).subscribe(friends => this.friends = friends);

    // console.log(this.friends);
  }
  getmyfriendname(){
    const data = {
      user_id: this.currentUser.success.user.id,
    };
    this.userService.viewUser(data).pipe(first<any[]>()).subscribe(friendsname => this.friendsname = friendsname);
  }
  sendMessage(): void {
    if (this.txtMessage) {
      this.message = new Message();
      this.message.user = this.currentUser.success.user.name;
      this.message.type = "sent";
      this.message.message = this.txtMessage;
      this.message.date = new Date();
      this.messages.push(this.message);
      this.chatService.sendMessage(this.message);
      this.txtMessage = '';
    }
  }
  private subscribeToEvents(): void {

    this.chatService.messageReceived.subscribe((message: Message) => {
      this._ngZone.run(() => {
        if (message.user !== this.currentUser.success.user.name) {
          message.type = "received";
          this.messages.push(message);
        }
      });
    });
  }
}
